<div class="queue-container">
	<div data-layout="row" data-layout-align="start center" class="no-label-list">
		<span style="width: 16px;" *ngIf="canBeLocked">
			<mat-icon *ngIf="item.locked" class="material-icons icon icon-dark va-middle icon-size-xs"
								aria-label="Lock" matTooltip='Locked by {{ item.lockedBy }} - {{ item.lockDate | date: dateFormat }}'
								[matMenuTriggerFor]="faxMenu" [matMenuTriggerData]="{item: item}">
				<span>lock_person</span>
			</mat-icon>
		</span>
		<mat-checkbox matTooltip="Select all pages" matTooltipPosition="after" matTooltipClass="tooltip" aria-label="Select all pages"
									(change)="onChange($event, item)" [value]="item.internalId" [disabled]="item.locked" [(ngModel)]="item.isSelected">
		</mat-checkbox>
		<button mat-button class="btn-multiline" title="Process {{ item.name }} - {{ item.p8DocName }}"
						(click)="dialogFaxSplit.openProcessSplitFax(item)" *ngIf="!splittingFax">
			<span class="value truncate block bold" aria-label="Date and time">{{ item.name }} {{ item.date | date: dateFormat : timezone}}</span>
			<span class="value text-sm" aria-label="Time" [ngClass]="item.color">{{ item.date | date: dateFormat : timezone}}</span><br *ngIf="item.externalDocumentId"/>
			<span *ngIf="item.externalDocumentId" class="value text-sm" aria-label="Queue"> {{ item.externalDocumentId }}</span><br/>
			<span class="value text-sm" aria-label="Queue"> {{ item.queueName }}</span>
		</button>
		<button mat-button title="Process {{ item.name }} - {{ item.p8DocName }}"
						(click)="dialogFaxSplit.openProcessSplitFax(item)" *ngIf="splittingFax" disabled>
			<mat-icon class="material-icons-outlined icon-dark" aria-label="Split file icon">content_copy</mat-icon>
			<span class="value" aria-label="Splitting">Splitting Fax...</span>
		</button>
	</div>
		<ul *ngIf="item['split'].length">
			<li *ngFor="let subItem of item['split']">
				<span style="width: 16px;" *ngIf="canBeLocked">
					<mat-icon *ngIf="subItem.locked" class="material-icons icon icon-dark va-middle icon-size-xs"
										aria-label="Lock"
										matTooltip='Fax locked by {{ subItem.lockedBy }} - {{ subItem.lockDate | date: dateFormat }}'
										[matMenuTriggerFor]="faxMenu" [matMenuTriggerData]="{item: subItem}">
						<span>lock_person</span>
					</mat-icon>
				</span>
				<mat-checkbox *ngIf="isSelectable" matTooltip="Select these pages" matTooltipPosition="after" matTooltipClass="tooltip" aria-label="Select these pages"
											(change)="onChange($event, subItem)" [value]="subItem.internalId" [(ngModel)]="subItem.isSelected" [disabled]="subItem.locked">
				</mat-checkbox>
				<button mat-button class="btn-multiline" title="Attach {{ subItem.name }}" (click)="dialogFaxSplit.openProcessSplitFax(subItem)">
					<mat-icon class="material-icons icon-dark icon-size-xs" aria-label="Split file icon">insert_page_break</mat-icon>
					<span class="value truncate block bold" aria-label="Date">{{ subItem.name }}</span>
					<span class="value truncate text-sm" aria-label="Time" [ngClass]="subItem.color">{{ subItem.date | date: dateFormat : timezone}}</span><br/>
					<span class="value truncate text-sm" aria-label="Queue"> {{ subItem.queueName }}</span>
				</button>
			</li>
		</ul>
</div>
<app-dialog-fax-split #dialogFaxSplit></app-dialog-fax-split>

<!-- standard material menu -->
<mat-menu #faxMenu="matMenu">
	<ng-template matMenuContent let-item="item">
		<button mat-menu-item (click)="unlockFax(item)" [controlBehavior]="'UnlockFax'">Unlock Fax</button>
	</ng-template>
</mat-menu>